import types from './types';
import { getErrorMessage } from '../../utils';
import { t } from 'i18next';

export default ({ type, request, data }) => {
  switch (type) {
    case types.NEW_ACCESS_REQUEST_SUCCESS:
      const { departmentOrExperiment, role } = request?.params?.accessRequestDto;
      if (data) {
        return {
          title: t('message.title.success.new.access.request'),
          type: 'success'
        };
      } else {
        return {
          title: t('message.title.error.new.access.request.is.duplicate', { role: t(role), departmentOrExperiment }),
          type: 'error'
        };
      }
    case types.NEW_ACCESS_REQUEST_FAILURE:
      return {
        title: t('message.title.error.new.access.request'),
        message: t(getErrorMessage(data)),
        type: 'error'
      };

    default:
      return false;
  }
};
